import { Observable } from 'rxjs';

/**
 * Extracts the base 64 encoded data from a data url
 */
export const ExtractBase64FromDataUrl = (dataUrl: string) => dataUrl.replace(/^data:.*;base64,/, '');

/**
 * Calculates the size of a file (in bytes) given a base 64 encoded string
 * See https://softwareengineering.stackexchange.com/questions/288670/know-file-size-with-a-base64-string
 */
export const CalculateFileSizeFromBase64 = (base64String: string): number => {
  return Math.round((base64String.length * 3) / 4) - 1;
};

/**
 * An observable that reads a file and emits it as an array buffer
 */
export const fromFileAsArrayBuffer = (file: File | Blob) =>
  new Observable<ArrayBuffer>((obs) => {
    const reader = new FileReader();

    reader.onerror = (err) => obs.error(err);
    reader.onabort = (err) => obs.error(err);
    reader.onload = () => obs.next(reader.result as ArrayBuffer);
    reader.onloadend = () => obs.complete();

    return reader.readAsArrayBuffer(file);
  });

/**
 * An observable that reads a file and emits it as a data url
 */
export const fromFileAsDataUrl = (file: File | Blob) =>
  new Observable<string>((obs) => {
    const reader = new FileReader();

    reader.onerror = (err) => obs.error(err);
    reader.onabort = (err) => obs.error(err);
    reader.onload = () => obs.next(reader.result as string);
    reader.onloadend = () => obs.complete();

    return reader.readAsDataURL(file);
  });
